import { cn } from '../../../../../../../utilities/cn';

interface PresetEditableCellProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  multiline?: boolean;
}

export function PresetEditableCell({
  value,
  onChange,
  className,
  multiline = false,
}: PresetEditableCellProps) {
  // Fills the padding-less cell; pastel blue marks it as editable.
  const inputClassName = cn(
    'block h-full w-full border-none bg-[var(--pastle-blue-lighter)] px-2 py-1.5 text-inherit outline-none transition-colors',
    'hover:cursor-pointer hover:bg-[var(--pastle-blue-light)] hover:outline hover:outline-[1.25px] hover:-outline-offset-1 hover:outline-blue-500',
    'focus:bg-[var(--pastle-blue-light)] focus:outline focus:outline-[1.25px] focus:-outline-offset-1 focus:outline-blue-500',
    className,
  );

  if (multiline) {
    return (
      <textarea
        className={cn(
          inputClassName,
          'min-h-[2.5rem] resize-y whitespace-pre-wrap break-words',
        )}
        value={value}
        rows={2}
        onChange={(event) => onChange(event.target.value)}
      />
    );
  }

  return (
    <input
      className={inputClassName}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
  );
}
